
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '@/contexts/ThemeContext';

export function ThemeSwitcher() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  
  const handleToggle = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light');
  };

  return (
    <div className="flex items-center space-x-2">
      <Sun size={16} className={`transition-colors ${resolvedTheme === 'light' ? 'text-foreground' : 'text-muted-foreground'}`} />
      <Switch 
        checked={theme === 'dark'} 
        onCheckedChange={handleToggle}
        aria-label="Toggle dark mode"
      />
      <Moon size={16} className={`transition-colors ${resolvedTheme === 'dark' ? 'text-primary' : 'text-muted-foreground'}`} />
    </div>
  );
}
